import React, { FC, ReactNode } from 'react';
import { StyledSectionTitle, StyledSection } from './Section.styles';

export interface SectionProps {
  name: string | string[];
  children: ReactNode;
}

const Section: FC<SectionProps> = ({ name, children, ...props }) => {
  let nameComp;
  if (name) {
    nameComp = (<div>{Array.isArray(name) ? (name.map((n) => <StyledSectionTitle key={n}>{n}</StyledSectionTitle>)) : (<StyledSectionTitle>{name}</StyledSectionTitle>)}</div>);
  }
  return (
    <StyledSection {...props}>
      {nameComp}
      {children}
    </StyledSection>
  );
};

export default Section;
